import i18n from '@/i18n'
i18n.mergeLocaleMessage('en', {
  "Quarter1": "Quarter 1",
  "Quarter2": "Quarter 2",
  "Quarter3": "Quarter 3",
  "Quarter4": "Quarter 4",
  "SCRNITM#yr": "Year",
  "LinkCopied": "Copied to Clipboard"
})
i18n.mergeLocaleMessage('zh', {
  "Quarter1": "一季度",
  "Quarter2": "二季度",
  "Quarter3": "三季度",
  "Quarter4": "四季度",
  "SCRNITM#yr": "年",
  "LinkCopied": "已复制"
})
i18n.mergeLocaleMessage('mm', {
  "Quarter1": "Quarter 1",
  "Quarter2": "Quarter 2",
  "Quarter3": "Quarter 3",
  "Quarter4": "Quarter 4",
  "SCRNITM#yr": "နှစ်",
  "LinkCopied": "ကလစ်ဘုတ်သို့ ကူးယူပြီးပါပြီ"
})
  